module.exports = __webpack_public_path__ + "6adb93ea5a803ddb10e8421830c72a93.svg";